import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../../context/AuthContext";
import { formatApiError } from "../../lib/api";

const AdminLogin = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      if (u.role !== "admin") {
        toast.error("Admin icazəsi yoxdur");
        return;
      }
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  const field = "w-full border border-brand-line bg-white px-4 py-3 text-sm outline-none focus:border-brand-ink transition-colors rounded-md";

  return (
    <div className="min-h-screen flex items-center justify-center bg-brand-bg px-6" data-testid="admin-login-page">
      <div className="w-full max-w-sm">
        <div className="text-center mb-10">
          <span className="font-serif text-3xl tracking-[0.25em]">SPARKLE</span>
          <p className="overline mt-2">Admin Panel</p>
        </div>
        <form onSubmit={submit} className="space-y-4 bg-white border border-brand-line rounded-md p-8">
          <div>
            <label className="overline block mb-2">Email</label>
            <input type="email" className={field} value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="admin-email" />
          </div>
          <div>
            <label className="overline block mb-2">Şifrə</label>
            <input type="password" className={field} value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="admin-password" />
          </div>
          <button type="submit" disabled={loading} data-testid="admin-login-btn" className="w-full bg-brand-ink text-white py-3 text-sm tracking-[0.15em] uppercase rounded-md hover:bg-brand-oxid transition-colors disabled:opacity-50">
            {loading ? "..." : "Daxil ol"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
